import React, { useEffect, useState } from 'react';
import NoDataComponent from '../../../shared/no-data/no-data';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { DOWNLOAD_SUPPORTERS, GET_ALL_SUPPORTERS } from '../../../constants/endpoints';
import { downloadBlob, getTagStyle } from '../../../utils/utils';
import { Button, Dropdown, Form } from 'react-bootstrap';
import FieldError from '../../../shared/fields-errors/field-error';
import { Link, useOutletContext } from 'react-router-dom';
import Loader from '../../../shared/loader/loader';
import { GET_TAGS } from "../../../constants/endpoints";
import './donor-tags.scss';

function Donors(props) {
    const columns = ['First Name', 'Last Name', 'Email', 'Total', 'No. of Donations', 'Location'];
    const methods = useForm();
    const { register, getValues, setValue, formState: { isValid, errors } } = methods;

    const [subscriberList, setSubscriberList] = useState([]);
    const [fileLoader, setFileLoader] = useState(false);

    const [pageIndex, setPageIndex] = useState(0);
    const [dataLoader, setDataLoader] = useState(false);
    //getting route context
    const {currencySign} = useOutletContext();
    const [optionsList, setOptionsList] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);

    const getAllSupporters = (pageIndex) => {
        setDataLoader(true);
        const formData = { ...getValues(), ...{ page_index: (pageIndex ? pageIndex : 0) } }
        axios.post(GET_ALL_SUPPORTERS, formData)
            .then((res) => {
                setDataLoader(false);
                res?.data?.status ? setSubscriberList(res?.data?.response) : setSubscriberList([]);
            }).catch((error) => {
                setDataLoader(false);
            })
    }

    const changePage = (index) => {
        setPageIndex(index);
        getAllSupporters(index);
    }

    useEffect(() => {
        getAllSupporters();
    }, [])

    const downloadCSV = () => {
        setFileLoader(true);

        axios.post(DOWNLOAD_SUPPORTERS, getValues(), { responseType: 'blob' })
            .then((res) => {
                setFileLoader(false);

                if (res?.data instanceof Blob) {
                    downloadBlob(res?.data, 'supporters_');
                } else {
                    alert('Failed to download file.');
                }
            }).catch((error) => {
                setFileLoader(false);
                alert('Failed to download file.');
            })
    }

    const searchWithCustomFilter = () => {
        getAllSupporters(0);
        setPageIndex(0);
    }

    const clearCustomSearch = (fields) => {
        for (let index = 0; index < fields.length; index++) {
            setValue(fields[index], undefined)
        }
        getAllSupporters(0);
        setPageIndex(0);
    }

    const handleTagCheckboxChange = (tagId) => {
        setSelectedTags(prev => 
            prev.includes(tagId) 
                ? prev.filter(tag => tag !== tagId)
                : [...prev, tagId]
        );
    }

    const handleApplyTags = () => {
        setValue('tag_ids', selectedTags.length > 0 ? selectedTags : undefined);
        searchWithCustomFilter();
    }

    const handleClearTags = () => {
        setSelectedTags([]);
        setValue('tag_ids', undefined);
        getAllSupporters(0);
        setPageIndex(0);
    } 

    // get tags for filter
    const fetchTags = () => {
        axios.get(GET_TAGS)
        .then((response) => {
            const sortedData = response.data.response; 
            setOptionsList(sortedData);
        })
        .catch((err) => {
            console.log(err?.response?.data?.message || "Failed to fetch tags. Please try again.");
        });
    }; 

    useEffect(() => {
      getAllSupporters();
      fetchTags();
    }, [])

   
    return (
        <div className='row'>
            <div className='col-xl-12'>
                <div>
                    <h5 className='font-weight-semibold text-black'>Donors</h5>
                </div>
            </div>

            {/* search start */}
            <div className='row'>

                {/* no of donations start */}
                <div className="col-md-2 mt-2">
                    <div className="dropdown">
                        <button className="shadow-none border-one w-100 border-radius-none btn dropdown-toggle" type="button" id="noOfDonations" data-bs-toggle="dropdown" aria-expanded="false">
                            Number of Donations
                        </button>
                        <ul onClick={(e) => e.stopPropagation()} className="dropdown-menu" aria-labelledby="noOfDonations">
                            <li className='p-3'>
                                <div className='row'>
                                    <div className='col-6'>
                                        <input
                                            {...register('no_donation_min', {
                                                valueAsNumber: true,
                                                validate: (value) => value >= 0,
                                            })}
                                            type='number' className='form-control' placeholder='Min' />
                                    </div>
                                    <div className='col-6'>
                                        <input
                                            {...register('no_donation_max', {
                                                valueAsNumber: true,
                                                validate: (value) => value >= 0,
                                            })}
                                            type='number' className='form-control' placeholder='Max' />
                                    </div>
                                </div>
                                <div className='mt-3 d-flex flex-column'>
                                    <button
                                        onClick={searchWithCustomFilter}
                                        type='button' className='mt-1 btn mb-0 btn-outline-primary'>Apply</button>
                                    <button
                                        onClick={() => clearCustomSearch(['no_donation_min', 'no_donation_max'])}
                                        type='button' className='mt-1 btn mb-0 btn-outline-secondary'>Clear</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* no of donations end */}

                {/* donation amount start */}
                <div className="col-md-2 mt-2">
                    <div className="dropdown">
                        <button className="shadow-none border-one w-100 btn-filter border-radius-none btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Donation Amount
                        </button>
                        <ul onClick={(e) => e.stopPropagation()} className="dropdown-menu">
                            <li className='p-3'>
                                <div className='row'>
                                    <div className='col-6'>
                                        <input
                                            {...register('donation_amount_min', {
                                                valueAsNumber: true,
                                                validate: (value) => value >= 0,
                                            })}
                                            type='number' className='form-control' placeholder='Min' />
                                    </div>
                                    <div className='col-6'>
                                        <input
                                            {...register('donation_amount_max', {
                                                valueAsNumber: true,
                                                validate: (value) => value >= 0,
                                            })}
                                            type='number' className='form-control' placeholder='Max' />
                                    </div>
                                </div>
                                <div className='mt-3 d-flex flex-column'>
                                    <button
                                        onClick={searchWithCustomFilter}
                                        type='button' className='mt-1 btn mb-0 btn-outline-primary'>Apply</button>
                                    <button
                                        onClick={() => clearCustomSearch(['donation_amount_min', 'donation_amount_max'])}
                                        type='button' className='mt-1 btn mb-0 btn-outline-secondary'>Clear</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* donation amount end */}


                {/* tags filter start */}
                <div className="col-md-2 mt-2">
                    <div className="dropdown">
                        <button className="shadow-none border-one w-100 btn-filter border-radius-none btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Tags {selectedTags.length > 0 ? `(${selectedTags.length})` : ''}
                        </button>
                        <ul onClick={(e) => e.stopPropagation()} className="dropdown-menu shadow-sm" style={{ minWidth: '200px', width: '100%' }}>
                            <li className='p-3'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            {
                                                optionsList && optionsList.length > 0 ? (
                                                    optionsList.map((opt, index) => {
                                                        const isChecked = selectedTags.includes(opt.id);
                                                        return (
                                                            <div key={index} className='tag-filter-item'>
                                                                <input
                                                                    type="checkbox"
                                                                    className='custom-tag-checkbox'
                                                                    id={`tag-${index}`}
                                                                    checked={isChecked}
                                                                    onChange={() => handleTagCheckboxChange(opt.id)}
                                                                />
                                                                <label className='form-check-label flex-grow-1 mb-0' htmlFor={`tag-${index}`} style={{ cursor: 'pointer' }}>
                                                                    {opt.bg ? (
                                                                        <span
                                                                            className="px-2 py-1 rounded d-inline-block"
                                                                            style={{
                                                                                background: opt.bg,
                                                                                color: getTagStyle(opt.bg).color,
                                                                                fontWeight: 500,
                                                                                fontSize: '12px',
                                                                                lineHeight: '1.2'
                                                                            }}
                                                                        >
                                                                            {opt.title}
                                                                        </span>
                                                                    ) : (
                                                                        <span style={{ fontSize: '13px', color: '#334155', fontWeight: 500 }}>
                                                                            {opt.title}
                                                                        </span>
                                                                    )}
                                                                </label>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="text-muted text-center py-2" style={{ fontSize: '12px' }}>
                                                        No tags available
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-3 d-flex flex-column gap-1'>
                                    <button
                                        onClick={handleApplyTags}
                                        type='button' className='mt-1 btn mb-0 btn-outline-primary'>Apply</button>
                                    <button
                                        onClick={handleClearTags}
                                        type='button' className='mt-1 btn mb-0 btn-outline-secondary'>Clear</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* tags filter end */}

                 {/* location filter start */}
                {/* <div className="col-md-2 mt-2">
                    <div className="dropdown">
                        <button className="shadow-none border-one w-100 btn-filter border-radius-none btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Location
                        </button>
                        <ul onClick={(e) => e.stopPropagation()} className="dropdown-menu">
                            <li className='p-3'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <input
                                            {...register('location')}
                                            type='text'
                                            className='form-control'
                                            placeholder='Search City or Country' />
                                    </div> */}
                                    {/* <div className='col-12 mt-2'>
                                        All Countries
                                        <ul class="list-group">
                                            <li class="list-group-item">
                                            <div className='mt-1'>
                    <label className="form-control-label d-flex align-items-center">
                    <input {...register("country", {
                        value: false
                    })} className='me-1' type="checkbox" /> United States
                    </label>
                </div>
                                                </li>
                                        </ul>
                                    </div> */}
                                {/* </div>
                                <div className='mt-3 d-flex flex-column'>
                                    <button
                                        onClick={searchWithCustomFilter}
                                        type='button' className='mt-1 btn mb-0 btn-outline-primary'>Apply</button>
                                    <button
                                        onClick={() => clearCustomSearch(['location'])}
                                        type='button' className='mt-1 btn mb-0 btn-outline-secondary'>Clear</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div> */}
                {/* location filter end */}
                {/* text filter */}
                <div className="col-md-4 mt-2">
                    <div className="form-group">
                        <div className="input-group">
                            <input
                                {...register('text_value', {
                                    value: ''
                                })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        getAllSupporters(0);
                                        setPageIndex(0);
                                    }
                                }}
                                type="text"
                                className="form-control"
                                placeholder="Search by name or email"
                            />
                            <button onClick={(e) => {
                                getAllSupporters(0);
                                setPageIndex(0);
                            }} type="button" className="btn btn-outline-secondary mb-0">Search</button>
                            <Dropdown>
                                <Dropdown.Toggle
                                    disabled={fileLoader}
                                    variant="default" id="dropdown-basic"
                                    className={`btn btn-outline-secondary mb-0 border-radius-none 
                                    ${fileLoader ? 'position-relative button--loading' : ''}`}>
                                    Export
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={downloadCSV}>Export All Columns</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
            {/* search end */}

            {/* donors listing start */}
            <div className='row mt-3 position-relative'>
                <div className='col-xl-12'>
                    <div className='card'>
                        <div className="table-responsive">
                            {
                                !dataLoader ? 
                                <table className="table align-items-center">
                                <thead className='text-center prayers-table-header white'>
                                    <tr>
                                        {
                                            columns.map((item, index) => {
                                                return <th key={index}>{item}</th>
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody className='prayer-table-body text-center'>
                                    {
                                        subscriberList.map((item, index) => {
                                            return <tr key={'supporters_' + index}>
                                                <td>
                                                    <Link to={`/donor-detail/${item?.id}/${item?.first_name + ' ' + item?.last_name}`} className='text-light-blue'>{item?.first_name}</Link></td>
                                                <td>
                                                    <Link to={`/donor-detail/${item?.id}/${item?.first_name + ' ' + item?.last_name}`} className='text-light-blue'>{item?.last_name}</Link>
                                                    </td>
                                                <td>{item?.email}</td>
                                                <td>
                                                    {currencySign}
                                                    {item?.total_amount}
                                                </td>
                                                <td>{item?.total_donations}</td>
                                                <td>{
                                                    item?.city && item?.country ?
                                                        (item?.city + ' ' + item?.country) : '-'}</td>
                                            </tr>
                                        })
                                    }

                                </tbody>

                            </table> : ''
                            }

                            {/* no data message */}
                            
                            {
                                !dataLoader && subscriberList?.length === 0 ?
                                <NoDataComponent message={'No Donors Found'} /> : ''
                            }
                        </div>
                    </div>

                    

                    <div className='mt-2 text-right'>
                        {
                            pageIndex ?
                                <Button
                                    onClick={() => {
                                        const index = pageIndex - 1;
                                        setPageIndex(index)
                                        changePage(index)
                                    }}
                                    className='me-2' type='button'
                                    variant="primary">
                                    Previous
                                </Button> : ''
                        }

                        <Button disabled={subscriberList?.length > 0 ? false : true} onClick={() => {
                            const index = pageIndex + 1;
                            setPageIndex(index)
                            changePage(index)
                        }} type='button'
                            variant="primary">
                            Next
                        </Button>
                    </div>
                </div>
                {
                                dataLoader ? 
                                <Loader /> : ''
                }
            </div>
            {/* subscribers listing end */}
        </div>
    );
}

export default Donors;